import Axios from 'axios'
import {accommodationTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_accommodation_types (context) {
    Axios.get(accommodationTypeUrls.getAllAccommodationTypes).then(function (response) {
      context.commit('GET_ALL_ACCOMMODATION_TYPES', response.data)
    })
  },
  get_accommodation_types (context, publicId) {
    Axios.get(accommodationTypeUrls.getAccommodationTypes + publicId).then(function (response) {
      context.commit('GET_ACCOMMODATION_TYPES', response.data)
    })
  },
  get_deleted_accommodation_types (context) {
    Axios.get(accommodationTypeUrls.getDeletedAccommodationType).then(function (response) {
      context.commit('GET_DELETED_ACCOMMODATION_TYPES', response.data)
    })
  },
  get_accommodation_type (context, publicId) {
    Axios.get(accommodationTypeUrls.getAccommodationType + publicId).then(function (response) {
      context.commit('GET_ACCOMMODATION_TYPE', response.data)
    })
  },
  post_accommodation_type (context, data) {
    Axios.post(accommodationTypeUrls.postAccommodationType, data).then(function () {
      context.dispatch('get_all_accommodation_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  update_accommodation_type (context, data) {
    Axios.post(accommodationTypeUrls.editAccommodationType, data).then(function () {
      context.dispatch('get_all_accommodation_types')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
      // console.log(error.data)
    })
  },
  delete_accommodation_type (context, publicId) {
    Axios.get(accommodationTypeUrls.deleteAccommodationType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_ACCOMMODATION_TYPES', response.data)
      router.push({
        name: 'Module.DeletedAccommodationTypes'
      })
    })
  },
  restoreAccommodationType (context, publicId) {
    Axios.get(accommodationTypeUrls.restoreAccommodationType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_ACCOMMODATION_TYPES', response.data)
      router.push({
        name: 'Module.AccommodationTypes'
      })
    })
  }
}
